import { FLAG_BY_LOCALE } from './flag-icons';
import de from './locales/de';
import el from './locales/el';
import en from './locales/en';
import es from './locales/es';
import fr from './locales/fr';
import it from './locales/it';
import nl from './locales/nl';
import pt from './locales/pt';
import ptBR from './locales/pt-BR';
import ru from './locales/ru';
import zh from './locales/zh';
import type {
  Locale,
  LocaleCode,
  LocaleMessageOverrides,
  LocaleMessageSchema,
} from './types';

export const LOCALE_MESSAGES: Record<
  LocaleCode,
  LocaleMessageSchema | LocaleMessageOverrides
> = {
  'en-GB': en,
  'en-US': en,
  'nl-NL': nl,
  'de-DE': de,
  'fr-FR': fr,
  'it-IT': it,
  'es-ES': es,
  'pt-PT': pt,
  'pt-BR': ptBR,
  'el-GR': el,
  'ru-RU': ru,
  'zh-CN': zh,
};

// What a kiosk's `languages` config and `/:slug/:localeCode` URL resolve
// against. pt-BR is left out on purpose so the kiosk UI stays pt-PT.
export const SUPPORTED_LOCALES: Locale[] = [
  { code: 'en-GB', title: 'English', icon: FLAG_BY_LOCALE['en-GB'] },
  { code: 'en-US', title: 'English', icon: FLAG_BY_LOCALE['en-US'] },
  { code: 'nl-NL', title: 'Nederlands', icon: FLAG_BY_LOCALE['nl-NL'] },
  { code: 'de-DE', title: 'Deutsch', icon: FLAG_BY_LOCALE['de-DE'] },
  { code: 'fr-FR', title: 'Français', icon: FLAG_BY_LOCALE['fr-FR'] },
  { code: 'it-IT', title: 'Italiano', icon: FLAG_BY_LOCALE['it-IT'] },
  { code: 'es-ES', title: 'Español', icon: FLAG_BY_LOCALE['es-ES'] },
  { code: 'pt-PT', title: 'Português', icon: FLAG_BY_LOCALE['pt-PT'] },
  { code: 'el-GR', title: 'Ελληνικά', icon: FLAG_BY_LOCALE['el-GR'] },
  { code: 'ru-RU', title: 'Русский', icon: FLAG_BY_LOCALE['ru-RU'] },
  { code: 'zh-CN', title: '中文', icon: FLAG_BY_LOCALE['zh-CN'] },
];

// Customer pages only, where it takes pt-PT's place (see visitor-locale.ts).
export const BRAZILIAN_PORTUGUESE: Locale = {
  code: 'pt-BR',
  title: 'Português',
  icon: FLAG_BY_LOCALE['pt-BR'],
};

// Fallback when no enabled-locale list is supplied. Must exist in SUPPORTED_LOCALES.
export const FALLBACK_LOCALE: LocaleCode = 'en-GB';

export const FALLBACK_LOCALES: Record<'pt-BR' | 'default', LocaleCode[]> = {
  'pt-BR': ['pt-PT'],
  default: [FALLBACK_LOCALE],
};
